export enum MENU_EFFECT_TYPE {
    CHANGE_PRODUCT = 'ChangeProduct',
    CHANGE_MATERIAL = 'ChangeMaterial',
    OPEN_URL = 'OpenUrl',
    CHANGE_VISIBILITY = 'ChangeVisibility',
    SET_URL = 'SetUrl',
}
